<p-card>
  <div class="color-swatches-container">
    <h2>Black</h2>
    <div class="color-swatches">
      <div
        class="color-swatch"
        *ngFor="let shade of blackScaleShades"
        [ngClass]="'color-swatch--' + blackScaleKey + '-' + shade"
      ></div>
    </div>
  </div>
  <div class="color-swatches-container">
    <h2>Grey</h2>
    <div class="color-swatches">
      <div
        class="color-swatch"
        *ngFor="let shade of greyScaleShades"
        [ngClass]="'color-swatch--' + greyScaleKey + '-' + shade"
      ></div>
    </div>
  </div>
  <div *ngFor="let key of colorKeys">
    <div class="color-swatches-container">
      <h2>{{ key | titlecase }}</h2>
      <div class="color-swatches">
        <div
          class="color-swatch"
          *ngFor="let shade of colorShades"
          [ngClass]="'color-swatch--' + key + '-' + shade"
        ></div>
      </div>
    </div>
  </div>
</p-card>
